import React from "react";
import '../index.css';
import TopBar from "../components/InsigniaTopBar";
import SideBar from "../components/InsigniaSideBar";
import Expenses from "../pages/Expenses";

function StudentsLayout(){
    return (
    <div className="d-flex flex-column" id="kt_app_root">
      {/* Top Navbar */}
      <TopBar />

      {/* Dashboard content container */}
      <div className="d-flex flex-grow-1">
        {/* Sidebar */}
        <SideBar />

        {/* Main Content Area */}
        <div className="flex-grow-1 p-4">
            <Expenses />
        </div>
      </div>
    </div>

    );
}

export default StudentsLayout;